export default __webpack_public_path__ + "static/media/ranking.9eaa5b84.svg";